import TenantContractDownload from './TenantContractDownload'

export default TenantContractDownload
